import BodyPassword from "../../account/BodyPassword";
import Footer from "../../shared/Footer";
import HeaderBar from "../HeaderBar/HeaderBar";

const ResetPassword = () => {
  return (
    <main className="ResetPassword" aria-labelledby="resetPasswordHeading">
      {/* <NavTagline /> */}
      <HeaderBar />
      <div className="layout-container">
        <div className="container">
          <div className="descript-container">
            <h1 id="resetPasswordHeading" className="form-title g-clr">Reset Password</h1>
            <p>Here is your request to reset your password. Contact CHS support at{" "}
            <a href="mailto:support@secureexsolutions.com" aria-label="Email CHS support at support@secureexsolutions.com">
              support@securexsolutions.com
            </a>{" "}
            or {" "}<a
                href="tel:18884709913,2"
                aria-label="Call SES support at 1-888-470-9913 extension 2"
              >
                1-888-470-9913 ext. 2
              </a>{" "}
              if you need assistance.
              </p>
          </div>
          <BodyPassword />
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default ResetPassword;